import { creatorApiClient as api } from './apiClient';

export interface ConversationMessage {
    id: string;
    draftId: string;
    role: 'user' | 'assistant' | 'system';
    content: string;
    actionType: string | null;
    actionPayload: Record<string, any> | null;
    actionResult: Record<string, any> | null;
    sentencesSnapshot: any[] | null;
    createdAt: string;
}

export interface ActionResult {
    success: boolean;
    preview: string;
    proposedSentences: any[];
    affectedIndices: number[];
}

export interface ConversationResponse {
    message: ConversationMessage;
    actionResult?: ActionResult;
    requiresConfirmation: boolean;
}

const BASE = '/creator/drafts';

export const conversationalEditingService = {
    sendMessage: async (draftId: string, message: string): Promise<ConversationResponse> => {
        const response = await api.post(`${BASE}/${draftId}/conversation`, { message });
        return response.data;
    },

    getHistory: async (draftId: string, limit?: number): Promise<ConversationMessage[]> => {
        const response = await api.get(`${BASE}/${draftId}/conversation`, {
            params: limit ? { limit } : undefined,
        });
        return response.data;
    },

    confirm: async (draftId: string): Promise<{ success: boolean; sentenceCount: number }> => {
        const response = await api.post(`${BASE}/${draftId}/conversation/confirm`);
        return response.data;
    },

    undo: async (draftId: string): Promise<{ success: boolean; sentenceCount: number; sentences?: any[] }> => {
        const response = await api.post(`${BASE}/${draftId}/conversation/undo`);
        return response.data;
    },

    redo: async (draftId: string): Promise<{ success: boolean; sentenceCount: number; sentences?: any[] }> => {
        const response = await api.post(`${BASE}/${draftId}/conversation/redo`);
        return response.data;
    },
};
